<template lang="html">
  <div class="onboarding-guide video-intro">
    <Guide
      :content="content"
      :contentHeading="contentHeading"
      :buttonText="nextText"
      backText="Close"
      :previousLink="closeLink"
      :closeLink="closeLink"
      :nextLink="nextLink"/>
  </div>
</template>

<script>
import {mapState} from 'vuex'

import Guide from '@/components/Guide'

export default {
  name: 'onboarding-video',

  data() {
    return {
      content: `<div class="demo-video"><iframe src="https://www.youtube.com/embed/e7NV0jSUm1k?controls=0&modestbranding=1&showinfo=0&autoplay=1" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;picture-in-picture; fullscreen" allowfullscreen></iframe></div>`
    }
  },

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    ...mapState(['currentUser']),

    closeLink() {
      return {
        name: 'site',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'onboarding-intro',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextText() {
      return `A message for ${this.firstName}`
    },

    firstName() {
      let name = this.currentUser.name || ''
      return name.split(' ')[0]
    },

    contentHeading() {
      return 'Welcome to the Site Builder!'
    }
  }
}
</script>

<style lang="sass">
  .onboarding-guide
    &.video-intro
      .col
        padding: 0

  .demo-video
    padding: 56.25% 0 0 0
    text-align: center
    position: relative
    margin-bottom: 10px
</style>
